@value height: 40.5px;
@value spacing: 10px;

.info {
    min-height: height;
    padding-bottom: spacing;
}

.info:last-child {
    padding-bottom: 0;
}

.placeholder {
    height: height;
    margin-bottom: spacing;
    width: 100%;
    border-radius: 3px;
    background-color: var(--off-white);
}

.placeholder:last-child {
    margin-bottom: 0;
}

.label {
    padding-bottom: 2px;
}

.label--new {
    composes: label;
    color: var(--plum);
}

.value {
    font-size: var(--font-normal);
    font-weight: 500;
    padding-right: 4px;
}

.value--new {
    composes: value;
    color: var(--plum);
}

.link-container a {
    color: var(--grey) !important;
    text-decoration: underline;
}

.link-container a:hover {
    color: var(--grey-dk) !important;
}

.link-container--new a {
    color: var(--plum) !important;
    text-decoration: underline;
}

.link-container--new a:hover {
    color: var(--company) !important;
}
